<div class="document-dialog-container">
  <button class="close-btn" mat-icon-button (click)="onClose()">
    <img
      src="assets/images/icons/close-icon.png"
      style="margin: 10px 10px; height: 12px; width: 12px"
    />
  </button>

  <div class="doc-content" *ngIf="selectedSearchType === 'Document Name'">
    <pdf-viewer
      [src]="safeUrl"
      [render-text]="true"
      [page]="0"
      [show-all]="false"
      [original-size]="false"
      [zoom]="1"
      [zoom-scale]="'page-fit'"
      [fit-to-page]="true"
      style="
        display: block;
        width: 100%;
        height: 300px;
        border-radius: 10px;
        background: #fff;
      "
    ></pdf-viewer>
  </div>

  <!-- <div class="doc-content" *ngIf="selectedSearchType === 'Document Content'">
    <div class="pdf-controls" *ngIf="showPages.length > 1">
      <button
        (click)="showPrevPage()"
        [disabled]="showPages.indexOf(currentPage) === 0"
      >
        ←
      </button>
      <span>
        Page {{ currentPage }} ({{ showPages.indexOf(currentPage) + 1 }} of
        {{ showPages.length }} matched)
      </span>
      <button
        (click)="showNextPage()"
        [disabled]="showPages.indexOf(currentPage) === showPages.length - 1"
      >
        →
      </button>
    </div>

    <div *ngIf="showPages.length === 0 && searchText">
      <em>No pages found with "{{ searchText }}"</em>
    </div>

    <pdf-viewer
      [src]="safeUrl"
      [render-text]="true"
      [page]="currentPage"
      [show-all]="false"
      [original-size]="false"
      [zoom]="1"
      [zoom-scale]="'page-fit'"
      [fit-to-page]="true"
      (after-text-layer-render)="onTextLayerRendered()"
      (after-load-complete)="afterLoadComplete($event)"
    ></pdf-viewer>
  </div> -->

  <!-- <div
    class="doc-content"
    *ngIf="selectedSearchType === 'Document Content' && isPdfReady"
  >
    <div *ngIf="showPages.length === 0 && searchText">
      <em>No pages found with "{{ searchText }}"</em>
    </div>

    <div *ngFor="let page of showPages">
      <pdf-viewer
        [src]="safeUrl"
        [render-text]="true"
        [page]="page"
        [show-all]="false"
        [original-size]="false"
        [zoom]="1"
        [zoom-scale]="'page-fit'"
        [fit-to-page]="true"
        (after-text-layer-render)="onTextLayerRendered()"
        (after-load-complete)="afterLoadComplete($event)"
        style="margin-bottom: 20px"
      ></pdf-viewer>
    </div>
  </div> -->

  <!-- <div
    class="doc-content"
    *ngIf="selectedSearchType === 'Document Content' && isPdfLoaded"
  >
    <div
      class="pdf-controls"
      *ngIf="totalPages > 1"
      style="margin-bottom: 10px"
    >
      <button (click)="showPrevPage()" [disabled]="currentPage === 1">
        ← Previous
      </button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button (click)="showNextPage()" [disabled]="currentPage === totalPages">
        Next →
      </button>
    </div>

    <pdf-viewer
      [src]="safeUrl"
      [render-text]="true"
      [page]="currentPage"
      [show-all]="false"
      [original-size]="false"
      [zoom]="1"
      [zoom-scale]="'page-fit'"
      [fit-to-page]="true"
      (after-text-layer-render)="onTextLayerRendered()"
      (after-load-complete)="afterLoadComplete($event)"
      style="
        display: block;
        width: 100%;
        height: 300px;
        border-radius: 10px;
        background: #fff;
      "
    ></pdf-viewer>
  </div> -->

  <div
    class="doc-content"
    *ngIf="selectedSearchType === 'Document Content' && safeUrl"
    style="
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <!-- Left Arrow Button: Show only if more than 1 page and not on first page -->
    <button
      *ngIf="totalPages > 1 && currentPage > 1"
      (click)="showPrevPage()"
      style="
        position: absolute;
        left: -5px;
        z-index: 10;
        background: transparent;
        border: none;
        font-size: 18px;
        cursor: pointer;
      "
    >
      <img src="assets/images/icons/Vector-Left.png" />
    </button>

    <!-- PDF Viewer Centered -->
    <div style="width: 80%; max-width: 800px">
      <pdf-viewer
        [src]="safeUrl"
        [render-text]="true"
        [page]="currentPage"
        [show-all]="false"
        [original-size]="false"
        [zoom]="1"
        [zoom-scale]="'page-fit'"
        [fit-to-page]="true"
        (after-text-layer-render)="onTextLayerRendered()"
        (after-load-complete)="afterLoadComplete($event)"
        style="
          display: block;
          width: 100%;
          height: 300px;
          border-radius: 10px;
          background: #fff;
        "
      ></pdf-viewer>
    </div>

    <!-- Right Arrow Button: Show only if more than 1 page and not on last page -->
    <button
      *ngIf="totalPages > 1 && currentPage < totalPages"
      (click)="showNextPage()"
      style="
        position: absolute;
        right: -12px;
        z-index: 10;
        background: transparent;
        border: none;
        font-size: 18px;
        cursor: pointer;
      "
    >
      <img src="assets/images/icons/Vector-Right.png" />
    </button>
  </div>

  <!-- <div class="view-more-link">
    <a (click)="openPdfInNewTab(data.url)" style="cursor: pointer"
      >Click Here to View More</a
    >
  </div> -->
  <div class="view-more-link">
    <a (click)="onViewMoreClick()" style="cursor: pointer"
      >Click Here to View More</a
    >
  </div>
</div>
